import { execAdmin } from '../utils';

const gql = String.raw;

interface GetColorSwatchUploadUrlArgs {
  partnerCode: string;
  colorCode: string;
  fileExtension: string;
  contentType: string;
}

interface ColorSwatchUploadUrlResult {
  uploadUrl: string;
  publicUrl: string;
}

interface GetColorSwatchUploadUrlResponse {
  partner: {
    getColorSwatchUploadUrl: ColorSwatchUploadUrlResult;
  };
}

interface GetColorSwatchUploadUrlVariables {
  partnerCode: string;
  colorCode: string;
  fileExtension: string;
  contentType: string;
}

const GET_COLOR_SWATCH_UPLOAD_URL_MUTATION = gql`
  mutation getColorSwatchUploadUrl(
    $partnerCode: String!
    $colorCode: String!
    $fileExtension: String
    $contentType: String
  ) {
    partner(code: $partnerCode) {
      getColorSwatchUploadUrl(
        colorCode: $colorCode
        fileExtension: $fileExtension
        contentType: $contentType
      ) {
        uploadUrl
        publicUrl
      }
    }
  }
`;

export const getColorSwatchUploadUrl = async ({
  partnerCode,
  colorCode,
  fileExtension,
  contentType,
}: GetColorSwatchUploadUrlArgs): Promise<ColorSwatchUploadUrlResult> => {
  const variables: GetColorSwatchUploadUrlVariables = {
    partnerCode,
    colorCode,
    fileExtension,
    contentType,
  };

  const response = await execAdmin<GetColorSwatchUploadUrlVariables, GetColorSwatchUploadUrlResponse>(
    GET_COLOR_SWATCH_UPLOAD_URL_MUTATION,
    { variables }
  );

  return response.partner.getColorSwatchUploadUrl;
};
